import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=00555bca&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"
import style0 from "./videos.vue?vue&type=style&index=0&id=00555bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00555bca",
  null
  
)

export default component.exports